import React from 'react'
import { features } from '../constants'

const FeatureSection = () => {
    return (
        <div className="relative mt-10">
            <div className="text-center">
                {/* <span className="bg-neutral-900 text-orange-500 rounded-full h-6 text-3xl font-medium px-2 py-1 uppercase">
                    FUNCIONALIDADES
                </span> */}
                <h2 className="text-3xl sm:text-5xl lg:text-6xl mt-10 lg:mt-10 tracking-wide">
                    Aprenda novas palavras, siga as trilhas de conhecimento
                    <span className="bg-gradient-to-r from-purple-500 to-purple-800 text-transparent bg-clip-text">
                        {' '}
                        e fixe o seu aprendizado com speaking, reading and listening!
                    </span>
                </h2>
            </div>
            <div className="flex flex-wrap mt-10 lg:mt-20">
                {features.map((feature, index) => (
                    <div key={index} className="w-full sm:1/2 lg:w-1/3">
                        <div className="flex">
                            <div className="flex mx-6 h-10 w-10 p-2 bg-neutral-900 text-purple-500 justify-center items-center rounded-full">
                                {feature.icon}
                            </div>
                            <div>
                                <h5 className="mt-1 text-xl">{feature.text}</h5>
                                <p className="text-md p-2 mb-20 text-neutral-500">{feature.description}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default FeatureSection
